import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthOrchestratorService } from '../auth/auth-orchestrator.service';
import { AuthWorkflowState } from '../auth/auth-workflow-state.enum';
import { AuthService } from '../auth/auth.service';
import { AuthorityService } from '../services/authority.service';

export const authenticatedGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const authOrchestratorService = inject(AuthOrchestratorService);

  const authorityService = inject(AuthorityService);
  const router = inject(Router); // Injecte le Router pour la redirection

  const isAuthenticated = await authService.isAuthenticated();
  const workflowState = authOrchestratorService.getWorkflowState();
  if (!isAuthenticated || workflowState !== AuthWorkflowState.FullyAuthenticated) {
    // if the user is not fully authenticated, restart the auth workflow process
    await authOrchestratorService.restartWorkflow();
    return false;
  }

  // Scopes check
  const requiredScopes: string[] | undefined = route.data['requiredScopes'];
  if (!requiredScopes || requiredScopes.length === 0) {
    return true;
  }

  const hasScopes = await authorityService.hasScopes(requiredScopes);
  if (!hasScopes) {
    await router.navigate(['/access-error'], { queryParams: { message: 'authenticatedGuard' } });
    return false;
  }

  return true;
};
